/** Load optional theme components only when their markup exists, including section updates. */
export async function loadOptionalModules(root, pending, importer = url => import(url)) {
  const jobs = [];
  for (const [tag, url] of pending) {
    if (!(root.nodeType === 1 && root.matches(tag)) && !root.querySelector?.(tag)) continue;
    pending.delete(tag); // Claim before importing: multiple mutations must not duplicate requests.
    jobs.push(Promise.resolve().then(() => importer(url)).catch(() => pending.set(tag, url)));
  }
  await Promise.all(jobs);
}

if (typeof document !== 'undefined') {
  const config = document.getElementById('mn-optional-modules');
  if (config) {
    const pending = new Map(Object.entries(JSON.parse(config.textContent)));
    const scan = root => loadOptionalModules(root, pending).then(() => {
      if (!pending.size) observer.disconnect();
    });
    const observer = new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node.nodeType === 1) scan(node);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    scan(document);
    window.addEventListener('online', () => scan(document));
    document.addEventListener('shopify:section:load', event => scan(event.target));
  }
}
